module.exports = __webpack_public_path__ + "static/img/2_muke.936d999c.png";